module.exports = __webpack_public_path__ + "static/media/in-logo-small-no-text.9e69fef6.png";